<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="p-3">
      <div class="overflow-auto">
        <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
          <thead>
          <tr>
            <th class="text-capitalize-first w-25">{{ helper.trans('labels.id') }}</th>
            <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in devices" :key="index" class="">
            <td>
              <span v-if="item.id" v-b-tooltip.hover :title="item.id">{{ item.id.substring(0, 8) }}...</span> <copy-button v-if="item.id"  :value="item.id"></copy-button>
            </td>
            <td v-if="!item.id">
              <input type="text" v-model="item.name" class="form-control form-control-sm">
            </td>
            <td v-else-if="currentEditDevice && currentEditDevice.id === item.id">
              <input type="text" v-model="currentEditDevice.name" class="form-control form-control-sm">
            </td>
            <td v-else>
              <i v-b-tooltip.hover :title="helper.trans(`labels.${item.status}_since`, {date: item.statusUpdatedAt ? dateHelper.format(item.statusUpdatedAt) : 'n/a'})" style="font-size: 70%" :class="{'text-success': item.status === 'online', 'text-secondary': item.status === 'offline'}" class="fa-solid fa-circle">
              </i> {{ item.name }}
            </td>
            <td class="text-end">
              <div v-if="!item.id || currentEditDevice && currentEditDevice.id === item.id">
                <button type="button" @click="save(index)" class="btn btn-sm btn-outline-success text-nowrap me-2"><i class="fa fa-save"></i></button>
                <button type="button" @click="cancel(index)" class="btn btn-sm btn-outline-dark text-nowrap"><i class="fa fa-cancel"></i></button>
              </div>
              <div v-else>
                <button type="button" @click="messageLogs(item)" class="btn btn-sm btn-outline-secondary text-nowrap me-2"><i class="fa-regular fa-comments"></i></button>
                <button type="button" @click="showApps(item)" class="btn btn-sm btn-outline-success text-nowrap me-2"><i class="fa-brands fa-android"></i></button>
                <button type="button" @click="edit(item)" class="btn btn-sm btn-outline-dark text-nowrap me-2"><i class="fa fa-pencil"></i></button>
                <button type="button" @click="remove(item)" class="btn btn-sm btn-outline-danger text-nowrap"><i class="fa fa-trash"></i></button>
              </div>

            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="3" class="text-center">
              <button type="button" @click="add()" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize-first w-100"><i class="fa fa-plus"></i> {{helper.trans('button.add')}}</button>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <b-modal :title="helper.trans('labels.android_apps')"
             :modelValue="appsModal !== null"
             footer-class="d-flex justify-content-end"
             @update:modelValue="$event === false && (appsModal = null)">
      <template #default>
        <LoaderWrapper :ref="(el) => loaderAppList = el" :zoom="0.5">
        <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
          <thead>
          <tr>
            <th class="text-capitalize-first">{{ helper.trans('labels.title')}}</th>
            <th class="text-capitalize-first">{{ helper.trans('labels.version')}}</th>
            <th class="text-capitalize-first">{{ helper.trans('labels.date')}}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="app in apps">
            <td>{{`app-${app.namespace}-${app.version}.apk` }}</td>
            <td>{{ app.version }}</td>
            <td>{{ dateHelper.format(app.created_at)}}</td>
            <td>
              <button type="button" @click="downloadApp(app)" class="btn btn-sm btn-outline-dark text-nowrap me-2"><i class="fa fa-download"></i></button>
              <button type="button" @click="registerDevice(appsModal!, app.version)" class="btn btn-sm btn-outline-primary text-nowrap me-2"><i class="fa fa-qrcode"></i></button>
            </td>
          </tr>

          </tbody>

        </table>
        </LoaderWrapper>
      </template>
      <template #footer>
        <button type="button" @click="appsModal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
          {{ helper.trans('button.ok')  }}
        </button>
      </template>
    </b-modal>

    <b-modal title="QR Code"
             :modelValue="qrCodeModal"
             footer-class="d-flex justify-content-end"
             @update:modelValue="qrCodeModal = $event">
      <template #default>
        <div class="d-flex justify-content-center" v-if="qrCodeKey">
          <div class="input-group">
            <input type="text" class="form-control form-control-sm font-monospace" :value="qrCodeKey" readonly>
            <copy-button class="btn btn-copy" :value="qrCodeKey"></copy-button>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <vue-qrcode v-if="qrCodeValue" :value="qrCodeValue" tag="svg" class="w-100" :options="{ width: '100%' }"></vue-qrcode>
        </div>

      </template>
      <template #footer>
        <button type="button" @click="qrCodeModal = false" class="btn btn-outline-dark btn-sm text-capitalize-first">
          {{ helper.trans('button.ok')  }}
        </button>
      </template>
    </b-modal>

    <b-modal :title="helper.trans('labels.message_logs', {'device_name': logsModalDevice?.name})"
             dialog-class="modal-xl"
             :modelValue="logsModalDevice !== null"
             footer-class="d-flex justify-content-end"
             @update:modelValue="$event === false && (logsModalDevice = null)">
      <template #default>
        <DeviceMessageLogs :device="logsModalDevice!"></DeviceMessageLogs>
      </template>
      <template #footer>
        <button type="button" @click.prevent="logsModalDevice = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
          {{ helper.trans('button.ok')  }}
        </button>
      </template>
    </b-modal>

  </LoaderWrapper>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import {useStore} from "vuex";
import {useNotification} from "@kyvg/vue3-notification";
import {BModal} from "bootstrap-vue-3";
import DeviceMessageLogs from "@/components/DeviceMessageLogs.vue";

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  components: {
    BModal,
    LoaderWrapper,
    CopyButton,
    DeviceMessageLogs,
  },
  props: {},
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderAppList = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const store = useStore()
    const state = reactive({
      qrCodeKey: null as string|null,
      qrCodeValue: null as string|null,
      qrCodeModal: false,
      appsModal: null as TraderDeviceDTO|null,
      apps: [] as any[],
      logsModalDevice: null as TraderDeviceDTO|null,
      currentEditDevice: null as TraderDeviceDTO|null,
      devices: [] as TraderDeviceDTO[]
    });


    const load = async () => {
      loader.value?.show()
      await store.dispatch("devices/loadList")
      state.devices =  Object.assign([], store.getters['devices/list']);
      loader.value?.hide()
    }

    const add = () => {
      const newDevice = {id: "", name: "", traderId: 0, trader: null, status: "offline", statusUpdatedAt: null} as TraderDeviceDTO;
      state.devices.push(newDevice)
    }

    const edit = (item: TraderDeviceDTO) => {
      state.currentEditDevice = {...item}
    }

    const remove = async (item: TraderDeviceDTO) => {
      loader.value?.show()
      await api.devicesDelete(item.id);
      await load()
      loader.value?.hide()
    }

    const save = async (index: number) => {
      const device = state.devices[index];

      loader.value?.show()
      if (!device.id) {
        state.devices[index] = await api.devicesCreate(device);
      } else if (state.currentEditDevice && state.currentEditDevice.id === device.id) {
        state.devices[index] = await api.devicesUpdate(state.currentEditDevice.id, state.currentEditDevice);
        state.currentEditDevice = null
      }
      store.dispatch("devices/loadList");
      loader.value?.hide()
    }

    const cancel = (index: any) => {
      const device = state.devices[index];

      if (state.currentEditDevice && device.id === state.currentEditDevice.id) {
        state.currentEditDevice = null;

        return;
      }

      state.devices = state.devices.filter((item: TraderDeviceDTO, dIndex: number) => dIndex !== index);
    }

    const download = async (item: TraderDeviceDTO) => {
      loader.value?.show()

      try {
        const data = await api.devicesDownload(item.id);
        const blob = new Blob([JSON.stringify(data)], {type: 'application/json'})
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `macrodroid_${item.name}.mdr`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e: any) {
        if (e.response && e.response.status === 400 && e.response.data) {
          for (const item of e.response.data) {
            notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
          }
        } else {
          throw e
        }
      }

      loader.value?.hide()
    }

    const messageLogs = async (item: TraderDeviceDTO) => {
      state.logsModalDevice = item
    }

    const showApps = async (item: TraderDeviceDTO) => {
      state.appsModal = item
      loaderAppList.value?.show()
      try {
        state.apps = await api.devicesListApps()
      } finally {
        loaderAppList.value?.hide()
      }
    }

    const downloadApp = async (app: any) =>  {
      loaderAppList.value?.show()
      try {

        const data = await api.deviceAppDownload(app.pk_id);
        const link = document.createElement("a");
        const url = URL.createObjectURL(new Blob([data]));
        link.href = url
        link.setAttribute('download', `app-${app.namespace}-${app.version}.apk`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } finally {
        loaderAppList.value?.hide()
      }

    }

    const registerDevice = async (item: TraderDeviceDTO, version: string) => {
      loader.value?.show()

      try {
        const data = await api.devicesRegisterDevice(item.id, version);
        state.qrCodeValue = data.qrCodeData;
        state.qrCodeKey = data.key;
        state.qrCodeModal = true;
      } catch (e: any) {
        if (e.response && e.response.status === 400 && e.response.data) {
          for (const item of e.response.data) {
            notification.notify({type: 'error', title: helper.trans(`server_errors.${item.code}`, {}, item.message)});
          }
        } else {
          notification.notify({type: 'error', title: helper.trans(`server_errors.INTERNAL_ERROR`)});
          throw e
        }
      } finally {
        loader.value?.hide()
      }
    }

    return {
      ...toRefs(state),
      loader,
      load,
      add,
      cancel,
      edit,
      remove,
      save,
      download,
      registerDevice,
      downloadApp,
      showApps,
      messageLogs,
      dateHelper,
      numberFormatter,
      helper,
      loaderAppList
    }
  }
})
</script>
